// extracted by mini-css-extract-plugin
export default {"wrapper":"KeywordsTable_wrapper__jPDVj","header":"KeywordsTable_header__Y3FVd","title":"KeywordsTable_title__xtmN4","titleWrap":"KeywordsTable_titleWrap__0pAAO"};